import api from 'api';
import { Icon, VirtualBody } from 'b3';
import React from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { Observable } from 'rxjs';
import { loadDudReasons, recordGoLiveDate, updateInterestLevel, updateInterestNotes } from '../../actions/ClientActions';
import { closeWizard, goBack, pushStep, updateCallData } from './logActivityReducer';
import './logcalldockform.less';
import PositionToggle from './PositionToggle';
import V2Wizard from './V2Wizard';
import WizardCompletedSuccess from './WizardCompletedSuccess';

@connect(
    state => ({
        client: state.activeClient.client,
        steps: state.logActivityWizard.steps,
		wizardTitle: state.logActivityWizard.wizardTitle,
        activeStepIndex: state.logActivityWizard.steps,
        currentStep: state.logActivityWizard.currentStep,
        notes: state.logActivityWizard.callData.notes,
        description: state.logActivityWizard.callData.description,
        autoFocusNotes: state.logActivityWizard.autoFocusNotes,
        showCompletedSuccess: state.logActivityWizard.showCompletedSuccess,
    }),
    { pushStep, closeWizard, updateCallData, goBack, updateInterestNotes, updateInterestLevel, loadDudReasons, recordGoLiveDate }
)
export default class LogCallDockForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			bottomHeight: null,
			interestLevels: [props.client.interestLevel],
		};
	}
	async componentDidMount() {		
	    this.setState({bottomHeight: this.getBottomHeight()});

	    this.resize$ = Observable.fromEvent(window, 'resize')
	    	.throttleTime(300)
	    	.subscribe((e) => {
				this.setState({bottomHeight: this.getBottomHeight()});
	    	});


	    var levelsV = await api.get('interest_levels');
	    var interestLevels = levelsV.value;
	    this.setState({interestLevels});

		this.props.loadDudReasons();
	}
	getBottomHeight = () => {
		var topHeight = this.topWrapper.getBoundingClientRect().height;
	    return window.innerHeight - topHeight;
	}
	componentWillUnmount() {
		this.props.closeWizard();
		this.resize$.unsubscribe();
	}
	handleNoteTextChange(notes, mentionedUsers) {
		this.props.updateCallData({notes, mentionedUsers});
	}
	focusNoteInput() {
		var noteInput = document.querySelector('#interest-note-wrapper textarea');
		noteInput.focus();
	}
	handleClose() {
		this.props.closeWizard();
	}
	changeInterestLevel(interestLevel) {
		this.props.updateInterestLevel(this.props.client.id, interestLevel);
	}
	recordGoLiveDate(date) {
		this.props.recordGoLiveDate(this.props.client.id, date);
	}
	render() {
		var { 
			client, 
			width, 
			position, 
			updatePosition, 
			description, 
			wizardTitle,
			showCompletedSuccess
		} = this.props;
		var { bottomHeight } = this.state;

		return (
			<VirtualBody>
				<div className="log-call-dock-form">
					{showCompletedSuccess &&
						<WizardCompletedSuccess />
					}
					<div className="top-wrapper" ref={el => this.topWrapper = el} style={{width}}>
						<div className="header-wrapper">
							<div className="add-call-icon">
								<Icon size={26} icon="call-add" />
							</div>
							<div className="log-call-header">
								<span>{wizardTitle}</span>
							</div>
							<div className="close-corner">
								<div className="close-icon">
									<Icon size={20} onClick={this.handleClose.bind(this)} icon="cross" showTooltipFor="close-dock" />
									<ReactTooltip id="close-dock" place='bottom' type='dark'>
										<span className="shortcut-tooltip-label">
											Close (<span className="shortcut-tooltip-shortcut-key">esc</span>)
										</span>
									</ReactTooltip>
								</div>
							</div>
						</div>
						<div className="agenda-header-wrapper">
							<Icon icon="check-list" />
							<strong>Agenda</strong>
							<span>Menu Position</span>
						</div>
						<div className="agenda-wrapper">
							<span className="agenda-and-phase-text">{description}</span>
							<div className="position-toggle-wrapper">
								<PositionToggle updatePosition={updatePosition} position={position} />
							</div>
						</div>
						<div className="agenda-header-wrapper">
							<Icon icon="timer" />
							<strong>Phase</strong>
						</div>
						<div>
							<span className="agenda-and-phase-text">{client.stageName}</span>
						</div>
					</div>
								
					<div className="bottom-wrapper" ref={el => this.bottomWrapper = el}>
						{bottomHeight &&
							<V2Wizard 
								height={bottomHeight} 
								width={width} />
						}
					</div>
				</div>
			</VirtualBody>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/LogCallDockForm.js